import styled from "styled-components";

export const Container = styled.header`
  height: 108px;

  background: var(--blue00);
  background: linear-gradient(90deg, rgba(0,66,115,1) 0%, rgba(0,120,208,1) 2%);
`;

export const Content = styled.div`
  width: 100%;
  max-width: 600px;
  height: 100%;
  padding: 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;

  @media (min-width: 1170px) {
    margin-left: 202.7px;
    padding-left: 50px;
  }
`

export const Image = styled.img`
  width: 92.07px;
  height: 80.14px;
`

export const HeaderTitle = styled.h1`
  height: fit-content;

  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
`
